import { render } from "./TheLoader.vue?vue&type=template&id=20e4bf5a&scoped=true"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"

import "./TheLoader.vue?vue&type=style&index=0&id=20e4bf5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e4bf5a"]])

export default __exports__